import { MoorEngineersComponent } from './features/MoorEngineers/Component';
import './App.css';
import './features/Templates/Templates.css';

function App() {
  return <MoorEngineersComponent />;
}

export default App;
